import React, { useEffect, useState, useContext } from "react";
import { Container, Row, Col, Form, Table, Button, Modal } from "react-bootstrap";
import { apiGet, apiPost } from "../utils/apiFetch";
import obj from "../utils/constants";
import apiPath from "../utils/apiPath";
import ReactPaginate from "react-paginate";
import { Link, useParams } from "react-router-dom";
import AuthContext from "../context/AuthContext";
import helpers from "../utils/helpers";
import { toast } from "wc-toast";
import { useForm } from "react-hook-form";

const MatchBetDetails = () => {
  let { user } = useContext(AuthContext);
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [open, setOpen] = useState(false);
  const [betId, setBetId] = useState({});
  const parmas = useParams();
  const getData = async () => {
    const { status, data: response_users } = await apiGet(
        apiPath.userEventsBetsDetail +
        "?betFaireType=" +
        parmas.betFaireType +
        "&eventId=" +
        parmas.eventId+
        "&marketId=" +
        parmas.marketId+
        "&selectionId=" +
        parmas.selectionId
    );
    if (status === 200) {
      if (response_users.success) {
        setData(response_users.results);
      }
    }
  };

  const onSubmit1 = async (request) => {
    setLoader(true);
    try {
      const { status, data: response_users } = await apiPost(
        apiPath.deleteBetData,
        {...betId, betFaireType:parmas.betFaireType}
      );
      if (status === 200) {
        if (response_users.success) {
          setLoader(false);
          toast.success(response_users.message);
          getData();
          setOpenToggle();
        } else {
          setLoader(false);
          toast.error(response_users.message);
        }
      }else{
        setLoader(false);
      }
    } catch (err) {
      setLoader(false);
      toast.error(err.response.data.message);
    }
  };

  const setOpenToggle = (betId, userId) => {
    setOpen(!open);
    setBetId({betId, userId});
  };

  const {
    register: register1,
    handleSubmit: handleSubmit1,
    formState: { errors: errors1 },
    reset: reset1,
  } = useForm({});

  useEffect(() => {
    getData();
  }, []);
  return (
    <div>
      <section className="main-inner-outer py-4">
        <Container fluid>
          <div className="db-sec">
            <h2 className="common-heading">Show Bet</h2>
          </div>
          <div className="inner-wrapper">
            <div className="common-container">
              {/* <Form className="bet_status">
                <Row>
                  <Col lg={4}>
                    <Row>
                      <Col
                        sm={12}
                        className="mb-lg-0 mb-3 d-flex justify-content-end"
                      >
                        <Link
                          to={"/MatchProfitLoss/" + parmas.eventId}
                          className="green-btn me-2"
                        >
                          Back
                        </Link>
                        <Link to="/BetListLive" className="green-btn me-2">
                          Live Match Bet
                        </Link>
                        <Link to="/rejected-bets" className="green-btn">
                          Rejected Bets
                        </Link>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Form> */}

              <div className="account-table batting-table">
                <div className="responsive">
                  <Table className="matchbetdetails-table">
                    <thead>
                      <tr>
                        <th scope="col">Sports</th>
                        <th scope="col"> Match Name</th>
                        <th scope="col">Client</th>
                        <th scope="col">Type </th>
                        <th scope="col">Selection</th>
                        <th scope="col">Odds</th>
                        <th scope="col">Stake</th>
                        <th scope="col">Place Time</th>
                        <th scope="col">IP</th>
                        <th scope="col">PnL</th>
                        <th scope="col">Result</th>
                        <th scope="col">Status</th>
                      </tr>
                    </thead>
                    {data && data?.length > 0 ? (
                      data?.map((item, index) => {
                        const result = (parmas?.betFaireType=="fancy")?(item?.type == "No" ? (
                            item?.decisionRun < item?.betRun ? item?.profitAmount: -item?.loseAmount
                          ): item?.decisionRun >= item?.betRun ? item?.profitAmount : -item?.loseAmount
                        )
                        :(parmas?.betFaireType=="betfair")?
                          (item?.teamSelectionWin == item?.selectionId && item?.betType == "back") || (item?.teamSelectionWin != item?.selectionId && item?.betType == "lay") 
                          ?item?.profitAmount
                          :-item?.loseAmount
                        :(item?.teamSelectionWin) ?( item?.isDeclared === true && item?.selectionId === item?.teamSelectionWin &&
                          item?.profitAmount
                         ):-item?.loseAmount;

                        return (
                          <tr className={
                            item?.betType == "lay" || item?.type == 'No'
                              ? "lay-bg-row"
                              : item?.betType == "back"|| item?.type == 'Yes'
                              ? "back-bg-row"
                              : ""
                          }>
                            <td>{item?.eventType}</td>
                            <td> {item?.matchName}</td>
                            <td> {item?.clientName}</td>
                            <td>{item?.betType || item?.type}</td>
                            <td> {item?.runnerName?`${item?.runnerName} || ${item?.decisionRun}`:item?.teamName}</td>
                            <td> {item?.betRun || item?.bhav}</td>
                            <td> {item?.amount}</td>
                            <td>
                              {" "}
                              {helpers.dateFormat(
                                item.timeInserted,
                                user.timeZone
                              )}
                            </td>
                            <td> {(item?.ipAddress) && item?.ipAddress.replace("::ffff:","") || "-"}</td>
                            <td>
                              {" "}
                              {(item?.betFaireType=="betfair")?(item?.teamSelectionWin == item?.selectionId &&
                              item?.betType == "back") ||
                            (item?.teamSelectionWin != item?.selectionId &&
                              item?.betType == "lay") ? (
                              <span className="text-success">
                                {item?.profitAmount}
                              </span>
                            ) : (
                              <span className="text-danger">
                                -({item?.loseAmount})
                              </span>
                            ):((item?.teamSelectionWin) ?(
                                item?.isDeclared === true &&
                                item?.selectionId === item?.teamSelectionWin?(
                                  <span className="text-success">
                                    {item?.profitAmount}
                                  </span>
                                ):(<span className="text-danger">
                                  -({item?.loseAmount})
                                </span>)
                              ):
                              item?.type == "No" ? (
                                  item?.decisionRun < item?.betRun ? (
                                    <span className="text-success">
                                      {item?.profitAmount}
                                    </span>
                                  ) : (
                                    <span className="text-danger">
                                      -({item?.loseAmount})
                                    </span>
                                  )
                                ) : item?.decisionRun >= item?.betRun ? (
                                  <span className="text-success">
                                    {item?.profitAmount}
                                  </span>
                                ) : (
                                  <span className="text-danger">
                                    -({item?.loseAmount})
                                  </span>
                                ))}
                            </td>
                            <td> {item?.decisionRun || item?.isDeclared === true ? "Yes" : "No"}</td>
                            
                            <td> {item?.status}</td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan={12}>
                          <span>You have no bets in this time period.</span>
                        </td>
                      </tr>
                    )}
                  </Table>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
      <Modal show={open} onHide={setOpenToggle} className="change-status-modal">
        
        <Modal.Body>
          <div className="test-status border-0">
            <Form
              className="change-password-sec"
              onSubmit={handleSubmit1(onSubmit1)}
            >
              <Form.Group className=" mb-2">
                <h4 className="modal-title-status h4 text-center mb-3">
                  Are you want to delete
                </h4>
              </Form.Group>

              <div className="text-center mt-4">
                <Button type="submit" className="green-btn">
                  {loader ? "Loading..." : "Submit"}
                </Button>{" "}
                <Button onClick={setOpenToggle} className="green-btn">
                  Cancel
                </Button>
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default MatchBetDetails;
